import { VHCRecordCheckWheelTyreItemInput, VhcRecordLogService } from 'api/generated';
import { ApiMutationOptions, useMutationWithNotifications } from 'api/utils/useMutationWithNotifications';

export type UpdateWheelItemInput = {
  logId: number;
  itemId: number;
  requestBody?: VHCRecordCheckWheelTyreItemInput;
};

export const useUpdateWheelItemMutation = (
  options?: ApiMutationOptions<typeof VhcRecordLogService.putVhcRecordsItemsWheelTyres, UpdateWheelItemInput>
) =>
  useMutationWithNotifications(
    ({ logId, itemId, requestBody }: UpdateWheelItemInput) =>
      VhcRecordLogService.putVhcRecordsItemsWheelTyres(logId, itemId, requestBody),
    options
  );
